import {AfterViewChecked, Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {fromEvent, merge, Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, map, startWith, takeUntil, tap} from 'rxjs/operators';

interface ProcessedHeadline {
  anchor: string;
  top: number;
  active?: boolean;
}

@Directive({
  selector: '[ccScrollSpy]',
})
export class ScrollSpyDirective implements AfterViewChecked, OnInit, OnDestroy {
  @Input('ccScrollSpySelector') selector = 'h2,h3';
  @Output('ccScrollSpy') readonly anchor = new EventEmitter<string>();

  private readonly destroyed = new Subject();
  private readonly headlines: ProcessedHeadline[] = [];

  constructor(private readonly elementRef: ElementRef<HTMLElement>) {
  }

  ngAfterViewChecked() {
    this.processHeadlines();
  }

  ngOnInit() {
    merge(
      fromEvent(window, 'scroll'),
      fromEvent(window, 'resize').pipe(tap(() => this.processHeadlines())),
    ).pipe(
      startWith(null),
      takeUntil(this.destroyed),
      debounceTime(10),
      map(() => this.getAnchor()),
      distinctUntilChanged(),
    ).subscribe(anchor => this.anchor.emit(anchor));
  }

  ngOnDestroy() {
    this.destroyed.next();
  }

  private processHeadlines() {
    this.headlines.length = 0;

    this.elementRef.nativeElement.querySelectorAll(this.selector).forEach((element: HTMLElement) => {
      const top = element.offsetTop;
      const anchor = element.getAttribute('id');

      this.headlines.push({ anchor, top });
    });
  }

  private getAnchor(): string {
    let anchor = '';

    for (let i = 0; i < this.headlines.length; i++) {
      const headline = this.headlines[i];
      if (headline.top >= window.scrollY + 20) {
        break;
      }

      anchor = headline.anchor;
    }

    return anchor;
  }
}
